'use client'

import { AUTH_USER_COOKIE } from '@/lib/auth-constants'

/** True when the readable auth_user cookie is present (JWT stays HTTP-only). */
export function hasAuthSession(): boolean {
  if (typeof document === 'undefined') return false
  return document.cookie
    .split(';')
    .some((c) => c.trim().startsWith(`${AUTH_USER_COOKIE}=`))
}

export function readAuthUserLabel(): string | null {
  if (typeof document === 'undefined') return null
  try {
    const match = document.cookie
      .split(';')
      .map((c) => c.trim())
      .find((c) => c.startsWith(`${AUTH_USER_COOKIE}=`))
    if (!match) return null

    const raw = decodeURIComponent(match.slice(`${AUTH_USER_COOKIE}=`.length))
    const trimmed = raw.trim()
    if (!trimmed) return null

    if (trimmed.startsWith('{')) {
      const o = JSON.parse(trimmed) as Record<string, unknown>
      const name =
        typeof o.name === 'string'
          ? o.name
          : typeof o.email === 'string'
            ? o.email
            : null
      return name?.trim() || null
    }
    return trimmed
  } catch {
    return null
  }
}

export interface AuthSessionResponse {
  authenticated: boolean
  user: string | null
}

export async function fetchAuthSession(): Promise<AuthSessionResponse> {
  const res = await fetch('/api/auth/session', { credentials: 'include' })
  if (!res.ok) {
    return { authenticated: false, user: null }
  }
  return res.json() as Promise<AuthSessionResponse>
}
